<template>
    <div class="become-an-author-page">
        <div class="container">
            <div class="become-an-author">
                <div v-if="errors.length > 0"
                     style="background-color: rgba(255,116,116,0.56); border: #ff0e00 solid 2px; padding: 8px; margin-bottom: 10px;">
                    <ul style="padding: revert; margin: revert">
                        <li style="list-style: square" v-for="error in errors"> {{ error }}</li>
                    </ul>
                </div>
                <div v-if="successes.length > 0"
                     style="background-color: rgba(141,255,116,0.56); border: #00ff04 solid 2px; padding: 8px; margin-bottom: 10px;">
                    <ul style="padding: revert; margin: revert">
                        <li style="list-style: square" v-for="success in successes"> {{ success }}</li>
                    </ul>
                </div>
                <h1>{{ $t('become_an_author') }}</h1>
                <div v-if="$store.state.language.code === 'ar'">

                    <p> يهتم موقع The Cradle بمنطقة غرب آسيا، ينشر التحليلات والتحقيقات والمقابلات حول القضايا السياسية
                        والاقتصادية والاجتماعية المتنوعة لهذا الإقليم.
                        <br> يرحب الموقع بالمقترحات التي تثري محتواه، والتي تعبّر عن زاوية مواجِهة للهيمنة على منطقتنا.
                    </p>
                    <h3 style="font-weight: bold; color: #a40404"> أحكام التقديم</h3>
                    <br>
                    <ul style="list-style: disc; margin-inline: 30px">
                        <li>نرجو إرسال عرض تقديمي من حوالى 100 إلى 200 كلمة، يتضمّن الفكرة الرئيسية للمقال التي يجب أن
                            تكون متعلقة بإحدى دول غرب آسيا، موضحًا أهميتها، وكذلك أهم النقاط التي تندرج ضمنه.
                        </li>
                        <li>يمكن إرسال العروض باللغتين العربية أو الإنكليزية.</li>
                        <li>يجب أن تكون المقترحات حصرية لموقعنا وغير مرسلة إلى أي جهة أخرى.</li>
                        <li> يجب أن يكتب المقال بلغة صحافية واضحة بعيدًا عن التعابير المنمقة.</li>
                    </ul>
                    <br>
                    <p style="font-weight: bold">نرحب بالمقالات التي تحتوي على معلومات حصرية للكاتب وبالتالي لموقع The
                        Cradle، على أن تستند على مقابلات أو تصريحات من مصادر موثوقة.</p>

                    <h3 style="font-weight: bold; color: #a40404">المقالات</h3>
                    <br>
                    <ul style="list-style: disc; margin-inline: 30px">
                        <li> يجب أن يتراوح عدد كلمات المقال الذي تتم الموافقة عليه بين 800 و1200 كلمة.</li>
                        <li> يجب أن يتم إرسال المقال في الموعد المتفق عليه من أجل تحريره وترجمته ونشره.</li>
                        <li>يجب أن تحتوي جميع التصريحات والحقائق الواردة في مقالكم بروابط تشعبية Hyperlinks لمصادرها
                            الأصلية.
                        </li>
                        <li>من المحبذ أن تحتوي المقالات على بيانات، يقوم فريقنا بتجهزيها بصريًا.</li>
                        <li>يرفق مع المقال صورة للكاتب وسيرة ذاتية مختصرة وروابط حساباته على مواقع التواصل الاجتماعي.
                        </li>
                    </ul>
                    <br>
                    <p style="font-weight: bold">يجب أن تخلو المقالات المرسلة من أي سلوك غير مهني أو غير أخلاقي.</p>

                    <p>نستقبل مقترحاتكم على البريد الإلكتروني التالي <a href="mailto: arabic@thecradle.co">
                        arabic@thecradle.co</a>.</p>
                </div>

                <p>{{ $t('if_you_have_a_new_idea') }}</p>
                <form action="/account/author" method="post" ref="authorForm">
                    <input type="hidden" name="_token" :value="csrf">
                    <div class="forms-style-1">
                        <div class="row">
                            <div class="col-md-6 col-sm-6">
                                <div class="input-row">
                                    <label>{{ $t('name') }} </label>
                                    <input name="name" type="text" :placeholder=" $t('name') "/>
                                </div>
                            </div>
                            <div class="col-md-6 col-sm-6">
                                <div class="input-row">
                                    <label>{{ $t('email') }} </label>
                                    <input type="text" name="email" :placeholder=" $t('email') "/>
                                </div>
                            </div>
                            <div class="col-md-12 col-sm-12">
                                <div class="input-row">
                                    <label>{{ $t('message') }}</label>
                                    <textarea name="message" :placeholder=" $t('write_your_message')"></textarea>
                                </div>
                            </div>
                            <div class="col-md-12 col-sm-12">
                                <div class="submit-btn">
                                    <input
                                        class="g-recaptcha"
                                        data-sitekey="6Ld3Xv8mAAAAAJSdwXb6BysaOps8-vQJMk9W_ej5"
                                        data-callback="submitForm"
                                        type="submit" :value="$t('submit')"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
let errors = [];
if (typeof pageErrors !== 'undefined') {
    errors = pageErrors;
}

let successes = [];
if (typeof pageSuccesses !== 'undefined') {
    successes = pageSuccesses;
}

export default {
    name: "BecomeAnAuthorPage",
    components: {},
    props: {},

    data() {
        return {
            errors: errors,
            successes: successes,
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),

        }
    },
    methods: {
        submitForm(response) {
            console.log(response)
            const form = this.$refs.authorForm;
            form.submit();
        }
    },
    mounted() {
        window.submitForm = this.submitForm;
    }
}
</script>

<style scoped>

</style>
